import React from 'react';

import { DarkText, Icon } from '@lyearn-team/frontend-components';

import ImperativePopupDark from 'components/ImperativePopupDark';
import * as s from './styles';

const messageText = (messageProps, type) => {
  const contentType = type.toLocaleLowerCase();
  switch (messageProps.errorType) {
    case 'AVAILABLE':
      return `This ${contentType} cannot be opened as it is available only after on ${messageProps.availableOn}`;
    case 'LOCKED':
      return `This ${contentType} is locked, please complete other required courses to make it unlocked.`;
    case 'LICENSE':
    default:
      return `This ${contentType} cannot be opened as you do not have required 'License-type' to access it. Please contact the account-admin in order to update it.`;
  }
};

const ContentAccessDeniedPopup = ({ onCancel, contentProps }) => {
  return (
    <React.Fragment>
      <div role="presentation" className={s.closeIconWrapper} onClick={() => onCancel()}>
        <Icon type="close" style={{ height: 16, width: 16, fill: 'inherit' }} />
      </div>
      <div className={s.imageWrapper}>
        <img src={window.constants.imageUrl + 'security_icon.png'} alt="security" />
      </div>
      <DarkText
        as="div"
        fontSize={18}
        bold={true}
        color="silver"
        letterSpacing="normal"
        className={s.mainText}
      >
        Cannot Access {contentProps.type}
      </DarkText>
      <DarkText
        as="div"
        fontSize={14}
        bold={false}
        color="silver"
        letterSpacing="normal"
        className={s.subText}
      >
        {messageText(contentProps.messageProps, contentProps.type)}
      </DarkText>
    </React.Fragment>
  );
};

export default function showContentAccessDeniedPopup(contentProps) {
  return ImperativePopupDark.show(({ onCancel }) => {
    function handleClose() {
      onCancel('CANCEL');
      if (
        window.location.href.includes('learner/home') ||
        window.location.href.includes('learner/courses')
      ) {
        window.location.href = `/#/learner`;
      }
    }

    return {
      props: {
        showPopup: true,
        header: null,
        onCloseClick: handleClose,
        onOverlayClick: handleClose,
        popupClassName: s.popup,
        stickyHeader: true,
        withPortal: true,
        popupWrapperZIndex: 10001
      },
      children: <ContentAccessDeniedPopup onCancel={handleClose} contentProps={contentProps} />
    };
  });
}
